export default __webpack_public_path__ + "static/arrow_right-a00daff1985195641bdae5b77001b6ca.png";